<template>
  <v-card
    flat
    style="flex-basis: 100%;"
    class="py-10 pl-4 d-flex flex-column"
    color="transparent"
  >
    <v-row
      class="d-flex flex-row"
    >
      <v-col
        cols="8"
      >
        <v-text-field
          v-model="data.email"
          label="Email"
          dense
          prepend-icon="mdi-email"
          class="pb-5"
          :rules="rules.email"
        />

        <v-text-field
          v-model="data.name"
          dense
          label="Name"
          prepend-icon="mdi-account"
          :rules="rules.required"
        />
      </v-col>
      <v-col
        cols="4"
        class="justify-end"
      >
        <v-card
          flat
          max-width="150px"
          rounded
          class="align-self-stretch"
        >
          <v-text-field
            height="100"
            readonly
            solo-inverted
            flat
            lable="Amount"
            :value="totalAmount"
            :prepend-inner-icon="currencyIcon"
            disabled
          />
        </v-card>
      </v-col>
    </v-row>
    <ship-to
      v-if="requireShipping"
      :is-good="isGood"
      v-on="$listeners"
    />
  </v-card>
</template>

<script>
import ShipTo from './ShipTo.vue'

export default {
  components: { ShipTo },
  props: {
    totalAmount: {
      type: Number,
      default: ()=>0
    },
    currencyIcon: {
      type: String,
      default: ()=>null
    },
    requireShipping: {
      type: Boolean,
    },
    isGood: {
      type: Boolean
    }
  },
  data(){
    return {
      rules: {
        email: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        required: [
          v => !!v || 'Field is required'
        ]
      },
      data: {}
    }
  },
  watch:{
    auth(v) {
      let {email, name} = v
      this.data = {email, name}
      this.$emit('changed', this.data)
    },
    data(v) {
      this.$emit('changed', v)
    }
  },
  mounted () {
    if (this.auth.email || this.auth.name) {
      this.data = {
        email: this.auth.email,
        name: this.auth.name
      }
    }
  },
}
</script>